import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "flow-root p-4" };
const _hoisted_2 = {
    key: 0,
    class: "text-lg text-center text-gray-500"
};
const _hoisted_3 = {
    key: 1,
    role: "list",
    class: "-mb-8"
};
const _hoisted_4 = { class: "relative pb-8" };
const _hoisted_5 = {
    key: 0,
    class: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200",
    "aria-hidden": "true"
};
const _hoisted_6 = { class: "relative flex space-x-3" };
const _hoisted_7 = { class: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" };
const _hoisted_8 = { class: "text-sm text-gray-500" };
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { key: 0 };
import { AnnotationIcon, CheckIcon, PencilIcon, XIcon, } from '@heroicons/vue/solid';
import { computed, inject, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'activityFeed',
    props: {
        activityList: {}
    },
    setup(__props) {
        const props = __props;
        const activityFeed = ref(props.activityList);
        const formatDate = inject('formatDate');
        const getComments = (event) => {
            const changes = JSON.parse(event.comment || '[]');
            const html = [];
            for (const obj of changes) {
                for (const key of Object.keys(obj)) {
                    for (const key2 of Object.keys(obj[key])) {
                        const textKey = key2.replace(/_/g, ' ');
                        html.push(`${textKey
                            .split(' ')
                            .map((text) => text.charAt(0).toUpperCase() + text.slice(1))
                            .join(' ')}: ${obj[key][key2].old} to ${obj[key][key2].new}`);
                    }
                }
            }
            if (html.length && formatDate) {
                html.push(`By ${event.userEmail} on ${formatDate(event.timeStampUTC, 'DD/MM/YYYY HH:mm')}`);
            }
            return html;
        };
        watch(() => props.activityList, () => {
            activityFeed.value = props.activityList;
        });
        // sort activity by timestamp (oldest event first)
        const timeline = computed(() => [...activityFeed.value].sort((a, b) => a.timestamp - b.timestamp));
        // enums for accessing correct backgrounds and icons
        const background = {
            TRUE: 'bg-green-500',
            FALSE: 'bg-red-500',
            MOREINFO: 'bg-gray-500',
            ASSIGNED: 'bg-green-500',
            REJECTED: 'bg-red-500',
            EDITED: 'bg-orange-500',
        };
        const icons = {
            TRUE: CheckIcon,
            FALSE: XIcon,
            MOREINFO: AnnotationIcon,
            ASSIGNED: CheckIcon,
            REJECTED: XIcon,
            EDITED: PencilIcon,
        };
        // enum for activity feed using message codes
        const messageCodes = {
            S1: 'Request created',
            L1: 'Admin assigned',
            L2: 'Request complete',
            L3: 'Approved by HROps',
            L4: 'More info supplied to HROps',
            LM3: 'More info requested by HROps',
            LM4: 'More info supplied to HROps',
            R1: 'Request rejected',
            A1: 'Approved by budget holder',
            A2: 'Responded to more info request',
            A3: 'Approved by HROps',
            A4: 'Responded to more info request',
            A5: 'Resourcing have advertised role',
            A6: 'Candidate CVs collected',
            A7: 'Candidate Selected',
            A8: 'Re-approved by budget holder',
            A9: 'Responded to more info request',
            A10: 'Re-approved by HROps',
            A11: 'Responded to more info request',
            A12: 'Offer made',
            A13: 'Offer sent to candidate',
            A14: 'Documents returned',
            A15: 'Notify internal teams',
            A16: 'Request complete',
            A17: 'Offer prepared',
            A18: 'Admin owner added',
            A19: 'Leaver raised',
            A20: 'Replied to more info request',
            A21: 'Sent to HROps',
            A22: 'Sent for HROps approval',
            M1: 'More info requested',
            M2: 'Replied to more info request',
            M3: 'More info requested',
            M4: 'Replied to more info request',
            M5: 'Terms of offer confirmed',
            M6: 'Terms of offer changed',
            M7: 'Checks complete and offer sent',
            M8: 'More info requested',
            M9: 'Terms amended',
            M10: 'More info requested by H2R',
            M11: 'Replied to more info request',
            M12: 'Replied to more info request',
            M13: 'Approved by HROps',
            M14: 'More info requested from HROps',
            M15: 'Message',
            M16: 'Replied to more info request',
            O01: 'Admin has processed offer',
            O02: 'Admin has requested more info',
            O03: 'More info supplied by hiring manager',
            O04: 'More info supplied by hiring manager',
            AM01: '',
            AM02: 'More info requested by H2R',
            U1: 'Changes made',
            AL1: 'Amendment letter emailed to employee',
            AL2: 'Amendment letter failed to send',
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.activityList?.length)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_2, "No activity to show..."))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timeline.value, (event, eventIdx) => {
                            return (_openBlock(), _createElementBlock("li", {
                                key: event.timestamp
                            }, [
                                _createElementVNode("div", _hoisted_4, [
                                    (eventIdx !== timeline.value.length - 1)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_5))
                                        : _createCommentVNode("", true),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("div", null, [
                                            _createElementVNode("span", {
                                                class: _normalizeClass([background[event.status], 'h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white'])
                                            }, [
                                                (_openBlock(), _createBlock(_resolveDynamicComponent(icons[event.status]), {
                                                    class: "h-5 w-5 text-white",
                                                    "aria-hidden": "true"
                                                }))
                                            ], 2)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_7, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_8, [
                                                    _createTextVNode(_toDisplayString(messageCodes[event.message]) + " ", 1),
                                                    (event.status === 'EDITED')
                                                        ? (_openBlock(), _createElementBlock("a", {
                                                            key: 0,
                                                            class: "underline text-blue-600 hover:text-blue-800",
                                                            href: "#",
                                                            onClick: _withModifiers(($event) => (event.show = !event.show), ["prevent"])
                                                        }, _toDisplayString(!event.show ? 'show' : 'hide'), 9, _hoisted_9))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createTextVNode(),
                                                (event.comment && event.show)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getComments(event), (comment, index) => {
                                                            return (_openBlock(), _createElementBlock("p", {
                                                                key: index,
                                                                class: "text-sm text-gray-500"
                                                            }, _toDisplayString(comment), 1));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ])
                                        ])
                                    ])
                                ])
                            ]));
                        }), 128))
                    ]))
            ]));
        };
    }
});
